export default "__VITE_ASSET__B1J8vzU7__"